import _defineProperty from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { RENT_TYPE } from '@spa/shared/constants/rentType';
import { CONTRACT_TYPE } from '@spa/shared/constants/contractType';
import { PROPERTY_UNIT_TYPE } from '@spa/shared/constants/unitTypes';
import { UNIT_TYPE_TRANSLATIONS } from '@spa/shared/constants/translations';
import { capitalizeFirstLetter } from '@spa/shared/utils/stringManipulation';
import { transformFeatures } from '@spa/shared/utils/transformers/property';
export var transformUnitsForSharedSpacesAndAmenities = function transformUnitsForSharedSpacesAndAmenities(t, units, photos, rentBy) {
  return units.reduce(function (acc, _ref, index) {
    var _photos$find$hash, _photos$find;
    var id = _ref.id,
      unitTypeCode = _ref.type_code,
      unitPhotos = _ref.photos,
      features = _ref.features;
    if (rentBy !== RENT_TYPE.ENTIRE_PROPERTY && (unitTypeCode === PROPERTY_UNIT_TYPE.BED || unitTypeCode === PROPERTY_UNIT_TYPE.BEDROOM)) {
      return acc;
    }
    var unitTypeIndex = units.filter(function (_ref2) {
      var type_code = _ref2.type_code;
      return type_code === unitTypeCode;
    }).reduce(function (acc, _ref3, index, array) {
      var unitId = _ref3.id;
      if (array.length === 1) {
        return acc;
      }
      return unitId === id ? index + 1 : acc;
    }, 0);
    var unitFeatures = transformFeatures(features);
    var unitPhoto = (unitPhotos !== null && unitPhotos !== void 0 ? unitPhotos : []).find(function (_ref4) {
      var unitPhotoId = _ref4.id,
        displayable = _ref4.displayable;
      return displayable && photos.some(function (_ref5) {
        var id = _ref5.id;
        return id === unitPhotoId;
      });
    });
    var hash = (_photos$find$hash = (_photos$find = photos.find(function (_ref6) {
      var id = _ref6.id,
        placeholder = _ref6.placeholder;
      return id === (unitPhoto === null || unitPhoto === void 0 ? void 0 : unitPhoto.id) && !placeholder;
    })) === null || _photos$find === void 0 ? void 0 : _photos$find.hash) !== null && _photos$find$hash !== void 0 ? _photos$find$hash : '';
    var unitName = "".concat(t(capitalizeFirstLetter(UNIT_TYPE_TRANSLATIONS[unitTypeCode])), " ").concat(unitTypeIndex ? unitTypeIndex : '').trim();
    return [].concat(_toConsumableArray(acc), [{
      id: id,
      hash: hash,
      unitFeatures: unitFeatures,
      unitName: unitName,
      unitTypeCode: unitTypeCode
    }]);
  }, []).sort(function (a, b) {
    return a.hash && !b.hash ? -1 : !a.hash && b.hash ? 1 : 0;
  });
};
export var transformFeaturesToCommonFeatures = function transformFeaturesToCommonFeatures(transformedUnits, propertyFeatures, unitId, rentByProperty) {
  return transformedUnits.reduce(function (acc, _ref7) {
    var id = _ref7.id,
      unitFeatures = _ref7.unitFeatures,
      unitName = _ref7.unitName;
    if (+unitId === id && !rentByProperty || !(unitFeatures !== null && unitFeatures !== void 0 && unitFeatures.length)) {
      return acc;
    }
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, unitName, unitFeatures));
  }, rentByProperty && !(propertyFeatures !== null && propertyFeatures !== void 0 && propertyFeatures.length) ? {} : {
    Apartment: propertyFeatures
  });
};
export var transformFeaturesProperty = function transformFeaturesProperty(propertyAggregate) {
  if (!propertyAggregate.property.features) {
    return '';
  }
  return propertyAggregate.property.features.reduce(function (filteredFeatures, feature) {
    if (feature.Exists) {
      return [].concat(_toConsumableArray(filteredFeatures), [feature.Code]);
    }
    return filteredFeatures;
  }, []).join(',');
};
export var transformRulesProperty = function transformRulesProperty(propertyAggregate) {
  var rules = propertyAggregate.property.rules || [];
  return rules.reduce(function (filteredRules, _ref8) {
    var exists = _ref8.exists,
      code = _ref8.code;
    return exists ? [].concat(_toConsumableArray(filteredRules), [code]) : filteredRules;
  }, []).join(',');
};
export var lastUpdate = function lastUpdate(offer) {
  var _offer$availability_s = offer.availability_summary_info,
    fixed_contract = _offer$availability_s.fixed_contract,
    standard_contract = _offer$availability_s.standard_contract,
    standard_unitary_contract = _offer$availability_s.standard_unitary_contract;
  var isFixed = offer.contract.type === CONTRACT_TYPE.FIXED;
  var isFixedUnitary = offer.contract.type === CONTRACT_TYPE.FIXED_UNITARY;
  var isUnitary = offer.property.unitary;
  if (isFixed || isFixedUnitary) {
    return fixed_contract.last_updated_at;
  }
  if (!isFixed && isUnitary) {
    return standard_unitary_contract.last_updated_at;
  }
  return standard_contract.last_updated_at;
};
export var verificationLevel = function verificationLevel(propertyAggregate, accommodationProvider) {
  var isPropertyVerified = propertyAggregate.property.verification.verified;
  var verifications = accommodationProvider.verifications;
  var isAllVerified = verifications.email_address && verifications.offline_id && verifications.phone;
  var isNoneVerified = !verifications.email_address && !verifications.offline_id && !verifications.phone;
  if (isPropertyVerified && isAllVerified) {
    return 2;
  }
  if (!isPropertyVerified && !isNoneVerified) {
    return 0;
  }
  return 1;
};